var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 30,
    viewBox: "0 0 375 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_1609)"
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    width: 538.177,
    height: 298.987,
    transform: "matrix(0.997859 -0.0654031 0 1 -26.2441 -279.605)",
    fill: "#6666FF"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    width: 538.177,
    height: 298.987,
    transform: "matrix(0.997859 -0.0654031 0 1 91 -287.3)",
    fill: "#6666FF"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    width: 538.177,
    height: 298.987,
    transform: "matrix(0.997859 -0.0654031 0 1 -86.0415 -268.986)",
    fill: "url(#paint0_linear_4_1609)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 543.451,
    height: 298.987,
    transform: "matrix(0.997859 -0.0654031 0 1 -86.0415 -281.896)",
    fill: "#6666FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4_1609",
    x1: -0.00000678272,
    y1: -35.0811,
    x2: 529.868,
    y2: -86.2458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6666FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6666FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_1609"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 119,
    fill: "white",
    transform: "translate(0 -89)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.9ce45ac63d3baf014004053d6cbb568e.svg";
export { ForwardRef as ReactComponent };